import type { InvestorRelationPortalFeatures } from "./store/state/user/types";

export const pageRoutes = {
  settings: "settings",
  user: "user",
  inbox: "inbox",
  dashboard: "dashboard",
  fundraising: "fundraising",
  portfolio: "portfolio",
  dataCollection: "data-collection",
  news: "news",
};

export const getInvestorSettingsRoute = (
  isFeatureEnabled: (feature: InvestorRelationPortalFeatures) => boolean
): string | undefined => {
  if (isFeatureEnabled("AccountSettingsViewer")) {
    return `${pageRoutes.settings}/lp/account`;
  }
  if (isFeatureEnabled("BankAccountsDetailsViewer")) {
    return `${pageRoutes.settings}/lp/bank`;
  }
  if (isFeatureEnabled("Membership")) {
    return `${pageRoutes.settings}/lp/members`;
  }
  return undefined;
};
